export default __webpack_public_path__ + "static/media/menu10.c65663cc.png";